import { Result } from 'domain/types';

import ReadBrandingClient from 'use-case/branding/read/readBrandingClient';
import ReadBrandingCriteria from 'use-case/branding/read/readBrandingCriteria';
import Branding from 'domain/entity/branding';

export type ReadBrandingResult = Result<Branding>;
export type ReadBranding = (criteria: ReadBrandingCriteria) => Promise<ReadBrandingResult>;

export default (readBrandingClient: ReadBrandingClient): ReadBranding => (criteria: ReadBrandingCriteria): Promise<ReadBrandingResult> =>
    readBrandingClient(criteria);
